import Head from 'next/head';
import React, { FC } from 'react';

interface Props {
	orgName?: string;
	theme: any;
	appName: string;
}

// Dynamically set the favicon based on the theme
// Does not work in Safari as Safari does not change the favicon when the theme changes.
// For Safari we just use the parkchirp favicon for now
const AppHead: FC<Props> = ({ orgName, theme, appName }) => (
	<Head>
		<title>{theme.platformName.name ? theme.platformName.name : appName}</title>
		{orgName ? (
			<link rel='icon' sizes='any' href={theme.favicon.src} />
		) : (
			<link rel='icon' sizes='any' href='/favicon-32x32.png' />
		)}
	</Head>
);
export default AppHead;
